import React, { FC, PropsWithChildren, createContext, useContext, useEffect, useState } from 'react'
import UserService, { Organization } from '../services/UserService'
import { useAuth } from '../context/AuthContext'

interface OrganizationsContextType {
  organizations: Organization[]
  setOrganizations: any
  isLoadingOrganizations: boolean
}

const initialContext: OrganizationsContextType = {
  organizations: [],
  setOrganizations: () => undefined,
  isLoadingOrganizations: true,
}

export const OrganizationsContext = createContext<OrganizationsContextType>(initialContext)

const OrganizationsContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [organizations, setOrganizations] = useState<Organization[]>([])
  const [isLoadingOrganizations, setIsLoadingOrganiztions] = useState<boolean>(true)
  const { loading } = useAuth()

  useEffect(() => {
    if (loading || organizations.length) return
    setIsLoadingOrganiztions(true)
    UserService?.listOrganizations()
      .then((response) => {
        if (response?.organizations) {
          setOrganizations(response.organizations)
        }
      })
      .finally(() => {
        setIsLoadingOrganiztions(false)
      })
  }, [loading, organizations.length])

  return (
    <OrganizationsContext.Provider
      value={{ organizations, setOrganizations, isLoadingOrganizations: isLoadingOrganizations }}
    >
      {children}
    </OrganizationsContext.Provider>
  )
}

export default OrganizationsContextProvider

export const useOrganizations = () => {
  return useContext(OrganizationsContext)
}
